import { mapApiToPhotos } from './map-api-to-photo';

import type { ICatalogItem, ICatalogItemApi } from 'src/interfaces';

export const mapApiToCatalogItem = ({
  has_discount,
  regular_price,
  max_amount,
  photos,
  ...rest
}: ICatalogItemApi): ICatalogItem => ({
  ...rest,
  hasDiscount: has_discount,
  regularPrice: regular_price,
  maxAmount: max_amount,
  photos: photos && mapApiToPhotos(photos),
});
